import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { BOOKING_URL } from "@/config";
import { BookingContext } from "@/booking";
import { NavigationHeader } from "@/components/NavigationHeader";
import { Hero } from "@/components/Hero";
import { ProblemSolution } from "@/components/ProblemSolution";
import { HowItWorks } from "@/components/HowItWorks";
import { ResultsCaseStudy } from "@/components/ResultsCaseStudy";
import { Testimonials } from "@/components/Testimonials";
import { FAQAccordion } from "@/components/FAQAccordion";
import { InsightsSection } from "@/components/InsightsSection";
import { InsightPost } from "@/components/InsightPost";
import { BookingSection } from "@/components/BookingSection";
import { Footer } from "@/components/Footer";

let lenisInstance = null;

const openBooking = () => {
  if (lenisInstance) {
    lenisInstance.scrollTo("#book-audit", { offset: -70 });
  } else {
    window.open(BOOKING_URL, "_blank", "noopener,noreferrer");
  }
};

const Landing = () => (
  <main>
    <Hero />
    <ProblemSolution />
    <HowItWorks />
    <ResultsCaseStudy />
    <Testimonials />
    <FAQAccordion />
    <InsightsSection />
    <BookingSection />
  </main>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, anchors: true });
    lenisInstance = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      lenisInstance = null;
    };
  }, []);

  return (
    <BookingContext.Provider value={{ openBooking }}>
      <div className="App">
        <BrowserRouter>
          <NavigationHeader />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/insights/:slug" element={<InsightPost />} />
          </Routes>
          <Footer />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </BookingContext.Provider>
  );
}

export default App;
